import {
  AtsRejectionReasonsListDocument,
  AtsRejectionReasonsListQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useRejectionReasons = (variables?: AtsRejectionReasonsListQueryVariables) => {
  const { data, loading } = useQuery(AtsRejectionReasonsListDocument, {
    variables,
  })

  return {
    loading,
    reasons: data ? data.ats.rejectionReasonsConnection.nodes : [],
  }
}
